// 引用css
import "../scss/base.scss";
import "../scss/main.scss";
// 开发引用html，热更新
if (process.env.NODE_ENV === "development") {
  require("raw-loader!../index.html");
  require("raw-loader!../_main.html");
}

// 兼容低版本ie
import "es5-shim";
import "es5-shim/es5-sham";
import $ from "jquery";
import * as common from './common';
import './event';

window.activity = {};

window.gameInfo = {
  game: {
    id: 0,
    name: ''
  },
  server: {
    id: 0,
    sid: 0,
    name: ''
  },
  role: {
    id: 0,
    name: ''
  },
}

window.addEventListener('load', () => {
  common.initSwiper();
})

$(function () {
  common.init();
})


